module.exports = __webpack_public_path__ + "static/media/reject.01851769.png";